import { customSchema } from "../../../schemas/custom-schema";
import { wrapIn } from "prosemirror-commands";
import { isNodeActive, wrapInBlockquote } from "../../../commands/custom-commands";

export default class BlockquoteButton {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.dataset.action = "blockquote";
    this.buttonElement.title = "Cita";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Cita";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Cita";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);

    this.action = this.buttonClickCallback();
    this.rejectFocusAction = this.buttonMouseDownCallback();
    this.buttonElement.addEventListener("click", this.action);
    this.buttonElement.addEventListener("mousedown", this.rejectFocusAction);
    containerElement.appendChild(this.buttonElement);
    this.update(editorView);
  }

  update(view) {
    const isActive = isNodeActive(view.state, customSchema.nodes.blockquote) ? "true" : "false",
      isEnabled = wrapInBlockquote(view.state, null);
    this.buttonElement.setAttribute("aria-pressed", isActive);
    this.buttonElement.disabled = !isEnabled;
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.action);
    this.buttonElement.removeEventListener("mousedown", this.rejectFocusAction);
    this.buttonElement.remove();
    this.action = null;
    this.rejectFocusAction = null;
    this.buttonElement = null;
    this.view = null;
  }

  buttonMouseDownCallback() {
    return (event) => {
      event.preventDefault();
    }
  }

  buttonClickCallback() {
    return () => {
    
      wrapInBlockquote(this.view.state, this.view.dispatch);
      this.view.focus();
    }
  }
}
